import { toast } from "react-toastify";
import ApiBase from "./base";
import i18n from "../translations";

export const _WALLET_URL = "wallet";

export async function getWallet(userId) {
  const response = await ApiBase.get(`${_WALLET_URL}s/${userId}`);

  return response;
}

export async function topUp(id, data) {
  const response = await ApiBase.post(`${_WALLET_URL}/topup/${id}`, data);
  if (response.success) toast.success(i18n.t("SUCCESS_TO_TOPUP"));

  return response;
}

export async function withdrawal(id, data) {
  const response = await ApiBase.post(`${_WALLET_URL}/withdraw/${id}`, data);
  if (response.success) toast.success(i18n.t("SUCCESS_TO_WITHDRAW"));

  return response;
}

export async function ownTransfer(data) {
  const response = await ApiBase.post(`${_WALLET_URL}/transfer/debit-to-credit`, data);
  if (response.success) toast.success(i18n.t("SUCCESS_TO_TRANSFER"));

  return response;
}
